import React from "react";
import "./IntegrationsSection.scss";

type Props = {
  title: string;
  icon?: React.ReactNode;
  children?: React.ReactNode;
};

export const IntegrationsSection: React.FC<Props> = ({
  title,
  icon,
  children,
}) => {
  return (
    <section className="integrations-section">
      <div className="integrations-section-header">
        {icon ? <span className="integrations-section-icon">{icon}</span> : null}
        <h2 className="integrations-section-title">{title}</h2>
      </div>
      {children ? (
        <div className="integrations-section-content">{children}</div>
      ) : null}
    </section>
  );
};

